import { variants } from '../../util';
var getIcon = function getIcon(variant) {
  switch (variant) {
    case variants.POSITIVE:
      return 'check-circle-small';
    case variants.NEGATIVE:
      return 'cancel-circle-small';
    default:
      return 'info-circle-small';
  }
};
export default getIcon;